import { useParams } from 'react-router-dom'
import { ApiError, getPage } from '../api/client'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { Fehlerhinweis, Ladehinweis } from '../components/States'
import { useResource } from '../hooks/useResource'
import { useSeo } from '../hooks/useSeo'
import { useT } from '../i18n'
import { Markdown } from '../markdown'
import { useShopConfig } from '../shopConfig'
import { NotFoundPage } from './NotFoundPage'

/**
 * Eine Seite des Ladens: Impressum, Widerruf, Datenschutz, „Über uns".
 *
 * Der Laden schreibt sie selbst, das Ladenfenster stellt sie nur dar. Deshalb
 * eine Route mit Handle statt einer Seite je Pflichttext: Welche es gibt,
 * entscheidet der Ladeninhaber im Backoffice, und eine fest eingebaute Liste
 * hier hätte spätestens bei der ersten eigenen Seite gefehlt.
 */
export function TextPage() {
  const t = useT()
  const { handle = '' } = useParams()
  const { shopName, primaryHost } = useShopConfig()
  const { data: seite, error, loading } = useResource((signal) => getPage(handle, signal), [handle])

  useSeo({
    title: seite ? `${seite.title} — ${shopName}` : shopName,
    // Kein Auszug aus dem Text als Beschreibung: Die ersten Zeilen einer
    // Widerrufsbelehrung sagen einer Suchmaschine nichts, was der Titel nicht
    // schon sagt, und stünden dann in jedem Ergebnis dieses Ladens.
    description: seite ? `${seite.title} — ${shopName}` : undefined,
    canonicalHost: primaryHost,
  })

  if (loading) return <Ladehinweis text={t('seite.laedt')} />

  // Die vorhandene 404-Seite, mit ihren Ausgängen: Ein Verweis auf eine Seite,
  // die es nicht mehr gibt, soll nicht in einer Sackgasse enden.
  if (error instanceof ApiError && error.status === 404) {
    return <NotFoundPage was={t('seite.nichtGefunden')} />
  }

  if (error != null || !seite) return <Fehlerhinweis fehler={error} />

  return (
    <>
      {/* Titel und Text der Seite schreibt der Laden — siehe i18n.tsx: Eine
          übersetzte Widerrufsbelehrung wäre keine Belehrung mehr. */}
      <Breadcrumbs pfade={[{ name: t('nav.startseite'), pfad: '/' }, { name: seite.title }]} />
      <article className="textseite">
        <h1>{seite.title}</h1>
        <Markdown text={seite.body} />
      </article>
    </>
  )
}
